const messages = {
  fa: {
    success: {
      save: "با موفقیت ذخیره شد.", send: "اطلاعات شما با موفقیت ارسال شد.", submit: "اطلاعات شما با موفقیت ثبت شد.",
      done: "عملیات با موفقیت انجام شد.", edit: "اطلاعات با موفقیت ویرایش شد.", delete: "با موفقیت حذف شد.",
      commentSent: "دیدگاه شما ارسال شد و پس از تأیید در سایت نمایش داده خواهد شد.",
    },
    error: {
      access: "شما به این بخش دسترسی ندارید.", notFound: "اطلاعات درخواستی پیدا نشد.", pageNotFound: "هنوز محتوایی وجود ندارد.",
      server: "ارتباط با سرور برقرار نشد.", post: "عملیات انجام نشد؛ لطفاً دوباره تلاش کنید.", upload: "حجم یا پسوند فایل مجاز نیست.",
      empty: "لطفاً فیلدهای الزامی را تکمیل کنید.", emptyTitle: "لطفاً عنوان را وارد کنید.", emptyComment: "لطفاً دیدگاه خود را بنویسید.",
      wrongMobile: "لطفاً شماره همراه را به‌درستی وارد کنید.", mobileNotFound: "شماره همراه واردشده پیدا نشد.",
      captcha: "کد امنیتی معتبر نیست.", emptyFields: "لطفاً موارد الزامی را تکمیل کنید.", emptySelect: "هیچ موردی انتخاب نشده است.",
    },
  },
  ar: {
    success: {
      save: "تم الحفظ بنجاح.", send: "تم إرسال معلوماتك بنجاح.", submit: "تم تسجيل المعلومات بنجاح.",
      done: "تمت العملية بنجاح.", edit: "تم تعديل المعلومات بنجاح.", delete: "تم الحذف بنجاح.",
      commentSent: "تم إرسال تعليقك وسيُنشر بعد الموافقة عليه.",
    },
    error: {
      access: "ليس لديك صلاحية الوصول إلى هذا القسم.", notFound: "لم يتم العثور على المعلومات المطلوبة.", pageNotFound: "لا يوجد محتوى حتى الآن.",
      server: "تعذّر الاتصال بالخادم.", post: "تعذّر إتمام العملية؛ يرجى المحاولة مجددًا.", upload: "حجم الملف أو امتداده غير مسموح.",
      empty: "يرجى تعبئة الحقول المطلوبة.", emptyTitle: "يرجى إدخال العنوان.", emptyComment: "يرجى كتابة تعليقك.",
      wrongMobile: "يرجى إدخال رقم هاتف محمول صحيح.", mobileNotFound: "لم يتم العثور على رقم الهاتف المحمول.",
      captcha: "رمز التحقق غير صحيح.", emptyFields: "يرجى تعبئة الحقول المطلوبة.", emptySelect: "لم يتم اختيار أي عنصر.",
    },
  },
  en: {
    success: {
      save: "Saved successfully.", send: "Your information was sent successfully.", submit: "Your information was submitted successfully.",
      done: "The operation completed successfully.", edit: "The information was updated successfully.", delete: "Deleted successfully.",
      commentSent: "Your comment was submitted and will appear after approval.",
    },
    error: {
      access: "You do not have access to this section.", notFound: "The requested information was not found.", pageNotFound: "No content is available yet.",
      server: "Could not connect to the server.", post: "The operation could not be completed. Please try again.", upload: "The file size or extension is not allowed.",
      empty: "Please complete the required fields.", emptyTitle: "Please enter a title.", emptyComment: "Please write your comment.",
      wrongMobile: "Please enter a valid mobile number.", mobileNotFound: "The mobile number was not found.",
      captcha: "The verification code is invalid.", emptyFields: "Please complete the required fields.", emptySelect: "No item has been selected.",
    },
  },
};

function currentMessages() {
  const language = localStorage.getItem("languageCode") || "fa";
  return messages[language] || messages.fa;
}

export default {
  get success() { return currentMessages().success; },
  get error() { return currentMessages().error; },
};
